exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".RoomManagement {\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n", "", {"version":3,"sources":["D:/code_workspace/vue_work/ming-iot-admin/src/assets/css/D:/code_workspace/vue_work/ming-iot-admin/src/assets/css/JanitorManagement.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;CACd","file":"JanitorManagement.css","sourcesContent":[".RoomManagement {\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--5-1!./node_modules/postcss-loader/lib??ref--5-2!./src/assets/css/JanitorManagement.css
// module id = bJAm
// module chunks = 1